<template>
    <div
        :class="`prestep-new data-caid-${currentCard.id}`"
        :style="client.customization && client.customization.prestep_custom_bg ? { 'background-image': 'url(' + $apiUrl + '/storage/' + client.customization.prestep_custom_bg + ')' } : {}"
    >
        <div class="prestep-new-top">
            <div class="prestep-new-top-logo">
                <img :src="$imgUrl(client.logo)">
            </div>
            <div class="prestep-new-top-close"
                v-if="currentCard.type_options && !currentCard.type_options.dont_show_skip_btn" @click="next('closed')">
                <img src="@/assets/img/clear.png" width="20">
            </div>

        </div>
        <div class="prestep-new-main">
            <div class="prestep-new-image-container">
                <v-img v-if="currentCard.image" class="prestep-new-image" :src="$imgUrl(currentCard.image)"
                    :alt="currentCard.image_alt" />
            </div>
            <div class="prestep-new-content">
                <h2 class="prestep-new-content-title" v-html="$processText(currentCard.title)"></h2>
                <p class="prestep-new-content-intro" v-html="$processText(currentCard.wysiwyg)"></p>
                <img v-if="!['new_prestep_question', 'poststep', 'poststep_advanced_question', 'new_prestep_general'].includes(currentCard.type)"
                    class="prestep-new-content-down-arrow" src="@/assets/img/down-arrow.png" width="24">

                <div v-if="currentCard.type === 'new_prestep_language' && $store.state.endUser.client.id !== 24">
                    <div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
                        v-html="$processText(currentCard.type_options.text_above_input)"></div>
                    <div class="btn prestep-new-btn transportation"
                        :class="{ active: $store.state.endUser.language === 'sv' && 1 === 2 }"
                        @click="setLanguage('sv')">
                        Svenska</div>
                    <div class="btn prestep-new-btn transportation"
                        :class="{ active: $store.state.endUser.language === 'en' && 1 === 2 }"
                        @click="setLanguage('en')">
                        English</div>
                </div>
                <div v-if="currentCard.type === 'new_prestep_language' && $store.state.endUser.client.id === 24">
                    <div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
                        v-html="$processText(currentCard.type_options.text_above_input)"></div>
                    <div class="btn prestep-new-btn transportation"
                        :class="{ active: $store.state.endUser.language === 'tr' && 1 === 2 }"
                        @click="setLanguage('tr')">
                        Turkish</div>
                    <div class="btn prestep-new-btn transportation"
                        :class="{ active: $store.state.endUser.language === 'en' && 1 === 2 }"
                        @click="setLanguage('en')">
                        English</div>
                </div>

                <div v-if="currentCard.type === 'new_prestep_question' || currentCard.type === 'poststep'">
                    <div v-if="currentCard.type_options && currentCard.type_options.text_above_input"
                        class="mt-2 prestep-quiz-question"
                        v-html="$processText(currentCard.type_options.text_above_input)">
                    </div>

                    <img class="prestep-new-content-down-arrow" src="@/assets/img/down-arrow.png" width="24">

                    <br>

                    <div v-for="(answer, index) in question" :key="index" class="btn prestep-new-btn transportation"
                        :class="{ active: isAnswer(answer) }" @click="answerQuestion(answer)">
                        {{ answer.value }}
                    </div>
                </div>

                <div v-if="currentCard.type === 'poststep_advanced_question'">
                    <div v-if="currentCard.type_options && currentCard.type_options.text_above_input"
                        class="mt-2 prestep-quiz-question"
                        v-html="$processText(currentCard.type_options.text_above_input)">
                    </div>

                    <img class="prestep-new-content-down-arrow" src="@/assets/img/down-arrow.png" width="24">

                    <br>

                    <div v-if="currentCard.type_options.question_type === 'open_ended'" class="prestep-new-content-open-ended">
                        <v-theme-provider light>
                            <v-textarea v-model="openEndedAnswer"
                                :label="__('write_your_answer', 'Skriv ditt svar')"
                                :rules="[v => (currentCard.type_options.max_characters ? v.length <= currentCard.type_options.max_characters : true) || __('max_characters_exceeded', 'Max antal tecken överskridet')]"
                                :success="isSubmittedSuccessfully"
                                :success-messages="isSubmittedSuccessfully ? [__('answer_submitted', 'Ditt svar har skickats in!')] : []"
                                outlined></v-textarea>
                        </v-theme-provider>
                    </div>
                    <div v-else v-for="(answer, index) in question" :key="index"
                        class="btn prestep-new-btn transportation" :class="{ active: isAnswer(answer) }"
                        @click="answerQuestion(answer)">
                        {{ answer.value }}
                    </div>
                </div>

                <div v-if="currentCard.type === 'new_prestep_consent'">
                    <div class="mb-7" ref="consent_text">
                        <v-checkbox hide-details v-model="consent">
                            <template v-slot:label>
                                <span class="consent-text"
                                    v-html="$processText(currentCard.type_options.consent_text)"></span>
                            </template>
                        </v-checkbox>
                    </div>
                </div>

                <div v-if="currentCard.type === 'new_prestep_address'">
                    <div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
                        v-html="$processText(currentCard.type_options.text_above_input)"></div>
                    <v-text-field :height="10" :placeholder="__('write_an_address', 'Skriv in en adress')" ref="to"
                        v-model="to" outlined></v-text-field>
                </div>

                <div v-if="currentCard.type === 'new_prestep_transport'">
                    <div class="mb-2" v-html="$processText(currentCard.type_options.text_above_input)"></div>
                    <div class="prestep-new-content-transportation" v-if="!currentCard.type_options.input_home_address">
                        <div class="btn prestep-new-btn transportation" v-for="layer in layers" :key="layer.id"
                            @click="setTransportation(layer)"
                            :style="isActive(layer.id) ? { 'background-color': (layer.icon_font_color || '#012169') + ' !important', 'border-color': layer.icon_font_color, 'color': '#fff' } : {}">
                            <i v-if="layer.icon_font" :class="layer.icon_font"></i>

                            <v-img v-if="layer.icon && !layer.icon_font" :src="$imgUrl(layer.icon)" height="20px" />

                            {{ layer.__title }}
                        </div>

                        <div class="btn prestep-new-btn transportation" :class="misc ? 'active' : ''"
                            @click="setMisc()">{{ __('prestep_other_transport', 'Annat') }}</div>
                    </div>
                </div>

                <div class="prestep-new-content-bottom center" v-if="currentCard.type === 'poststep_advanced_question' && currentCard.type_options.question_type === 'open_ended'">
                    <div class="btn prestep-new-btn"
                        :class="{ submitting: isSubmitting, disabled: isButtonDisabled }"
                        @click="next('continue')">
                        {{ (currentCard.type_options && currentCard.type_options.btn_text)
                || capitalize(__('prestep_next', 'Gå vidare'))
                        }}
                    </div>
                </div>

                <div class="prestep-new-gdpr"
                    v-if="(currentCard.type_options && currentCard.type_options.gdpr_link) || client.footer_wysiwyg">
                    <div v-if="client.footer_wysiwyg" v-html="$processText(client.footer_wysiwyg)"></div>
                    <a v-if="!client.footer_wysiwyg" :href="$processText(currentCard.type_options.gdpr_link)"
                        target="_blank"
                        v-html="currentCard.type_options.gdpr_link_title || __('how_we_handle_data')"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'PostStep',
    props: ['card'],

    mounted() {
        if (this.card.redirect_delay && this.card.redirect_url) {
            setTimeout(() => {
                window.location.href = this.card.redirect_url
            }, this.card.redirect_delay)
        }
        this.$metric({ 'event': 'poststep_interaction', 'InteractionType': 'loaded' })
        // Emit initial state after component is fully mounted
        this.$nextTick(() => {
            this.$emit('next-button-visibility', this.shouldShowCarouselNextButton)
        })
    },

    data() {
        return {
            to: '',
            activeLayer: null,
            index: 0,
            misc: false,
            consent: false,
            answers: [],
            openEndedAnswer: '',
            multiAnswers: [],
            isSubmitting: false,
            isSubmittedSuccessfully: false
        }
    },

    methods: {
        isActive(id) {
            if (!this.activeLayer) {
                return null
            }

            return this.activeLayer.id === id ? 'active' : 'not-active'
        },

        async next(type) {
            if (this.isSubmitting || this.isButtonDisabled) {
                return
            }

            this.$metric({ 'event': 'poststep_interaction', 'InteractionType': type })

            if (this.currentCard.type === 'poststep_advanced_question') {
                if (this.currentCard.type_options.question_type === 'open_ended') {
                    this.isSubmitting = true
                    this.isSubmittedSuccessfully = false
                    try {
                        await this.answerQuestion({ key: this.openEndedAnswer, value: this.openEndedAnswer })
                        this.isSubmittedSuccessfully = true
                    } catch (error) {
                        console.error('Error submitting answer:', error)
                        this.isSubmittedSuccessfully = false
                    } finally {
                        this.isSubmitting = false
                    }
                }
            }

            if (this.card.redirect_url) {
                window.location.href = this.card.redirect_url
            }
        },

        capitalize(string) {
            return string[0].toUpperCase() + string.slice(1)
        },

        async answerQuestion(answer) {
            let previousIndex = this.answers.findIndex(a => {
                return a.title === this.currentCard.type_options.text_above_input
            })

            let newAnswer = {
                title: this.currentCard.type_options.text_above_input,
                answer: answer.value
            }

            if (previousIndex !== -1) {
                this.$set(this.answers, previousIndex, newAnswer)
            } else {
                this.answers.push(newAnswer)
            }

            let answerToSend = answer.key;
            // If the question is open ended, send the answer as the openEndedAnswer
            if (this.currentCard.type_options.question_type === 'open_ended') {
                answerToSend = this.openEndedAnswer
            } else if (this.currentCard.type === 'poststep_advanced_question' && this.currentCard.type_options.question_type === 'multiple_choice') {
                if (this.multiAnswers.includes(answer.key)) {
                    this.multiAnswers = this.multiAnswers.filter(a => a !== answer.key)
                } else {
                    if (this.currentCard.type_options.maximum_allowed_answers && this.multiAnswers.length >= this.currentCard.type_options.maximum_allowed_answers) {
                        // Remove the first answer to make room for the new one (FIFO)
                        this.multiAnswers.shift();
                    }
                    this.multiAnswers.push(answer.key)
                }
                answerToSend = this.multiAnswers.join(',')
            }

            return await axios.post(this.$apiUrl + '/api/survey/11', {
                question: this.currentCard.type_options.text_above_input,
                cardId: this.currentCard.id,
                answer: answerToSend,
                uuid: this.currentCard.id,
                slug: this.$store.state.endUser.slug,
            })
        },

        isAnswer(answer) {
            if (this.currentCard.type === 'poststep_advanced_question' && this.currentCard.type_options.question_type === 'multiple_choice') {
                return this.multiAnswers.includes(answer.key)
            }
            return this.answers.find(a => {
                return a.title === this.currentCard.type_options.text_above_input && a.answer === answer.value
            })
        },

        setTransportation(layer) {
            if (this.activeLayer && !this.activeLayer.show_as_default) {
                this.activeLayer.active = false
                this.activeLayer.point_categories = this.activeLayer.point_categories.map(c => ({ ...c, active: false }))
            }

            this.activeLayer = layer

            if (layer.title.includes('Promenad')) { this.$store.state.directions.travelMode = 'WALKING' }
            if (layer.title.includes('Cykel')) { this.$store.state.directions.travelMode = 'BICYCLING' }
            if (layer.title.includes('Kollektiv')) { this.$store.state.directions.travelMode = 'TRANSIT' }

            layer.active = true
            layer.point_categories = layer.point_categories.map(c => ({ ...c, active: layer.active }))

            this.$metric({ 'event': 'poststep_interaction', 'InteractionType': 'transportation', 'TransportationType': layer.title })
        },
    },

    computed: {
        currentCard() {
            return this.card
        },

        mapsApi() {
            return this.$store.state.mapsApi
        },

        client() {
            return this.$store.state.client
        },
        question() {
            let rows = this.currentCard.type_options.question.split('\r\n')

            return rows.map(r => {
                let split = r.split(' : ')

                return {
                    key: split[0],
                    value: split[1]
                }
            })
        },
        layers() {
            return this.$store.getters.translatedLayers
                .filter(l => l.show_in_menu && !l.hidden)
                .filter(l => l.title !== 'Mer' && l.title !== 'More')
        },
        isButtonDisabled() {
            if (this.currentCard.type === 'poststep_advanced_question' &&
                this.currentCard.type_options &&
                this.currentCard.type_options.question_type === 'open_ended') {
                return !this.openEndedAnswer || this.openEndedAnswer.trim().length === 0
            }
            return false
        },
        shouldShowCarouselNextButton() {
            // If question is not required, always show the next button
            if (this.currentCard.type_options
                && this.currentCard.type_options.question_type === 'open_ended'
                && !this.currentCard.type_options.is_required
            ) {
                return true
            }
            // Hide carousel next button for open_ended questions until submission is successful
            if (this.currentCard.type === 'poststep_advanced_question' &&
                this.currentCard.type_options &&
                this.currentCard.type_options.question_type === 'open_ended') {
                return this.isSubmittedSuccessfully
            }
            // For other poststep types, show the carousel next button
            return true
        }
    },
    watch: {
        isSubmittedSuccessfully(newValue) {
            if (newValue === true) {
                this.$emit('next-button-visibility', this.shouldShowCarouselNextButton)
            }
        }
    }
}
</script>
